import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Footer from './Footer';

export default function ShareScreen() {
  const { pollId } = useParams();
  const navigate   = useNavigate();
  const [copied, setCopied]   = useState(false);

  const pollUrl = `https://galacticmeeting.com/poll/${pollId}`;

  const copy = () => {
    navigator.clipboard.writeText(pollUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  return (
    <main
      id="main-content"
      className="fade-up"
      style={{
        maxWidth: 520, margin: '80px auto', padding: '0 24px',
        textAlign: 'center', position: 'relative', zIndex: 1,
      }}
    >
      <div style={{ fontSize: 52, marginBottom: 20 }} aria-hidden="true">🚀</div>

      <h1 style={{ fontSize: '2rem', marginBottom: 10 }}>Poll created!</h1>
      <p style={{ color: 'var(--muted)', fontSize: 15, marginBottom: 36 }}>
        Share this Galactic Meeting poll link with your crew. No login required to vote.
      </p>

      <div className="card" style={{ textAlign: 'left', marginBottom: 20 }}>
        <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8 }} id="share-link-label">Share link</div>
        <div
          aria-labelledby="share-link-label"
          style={{
            background: 'var(--surface2)', borderRadius: 8,
            padding: '12px 16px', fontSize: 13, wordBreak: 'break-all',
            color: 'var(--accent2)', marginBottom: 14,
          }}
        >
          {pollUrl}
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={copy}
            aria-label={copied ? 'Link copied' : 'Copy link to clipboard'}
            aria-live="polite"
            style={{
              flex: 1, padding: '10px', borderRadius: 8,
              border: '1px solid var(--border2)', background: 'var(--surface2)',
              fontSize: 14, color: copied ? 'var(--green)' : 'var(--muted)',
              cursor: 'pointer', transition: 'all 0.2s',
            }}
          >
            {copied ? '✓ Copied!' : 'Copy link'}
          </button>
          <button className="btn-primary" style={{ flex: 1 }} onClick={() => navigate(`/poll/${pollId}`)}>
            View poll →
          </button>
        </div>
      </div>

      <button
        style={{
          color: 'var(--muted)', fontSize: 13, textDecoration: 'underline',
          cursor: 'pointer', background: 'none', border: 'none',
        }}
        onClick={() => navigate('/')}
      >
        ← Create another poll
      </button>

      <Footer />
    </main>
  );
}
